import { useCallback, useRef } from "react";

/**
 * 항상 최신 구현을 호출하는 identity-안정 핸들러. memo 경계를 넘는 콜백 prop이 렌더마다
 * 재생성되어 memo를 무효화하는 것을 막는다(useEffectEvent 패턴). 렌더 중 호출 금지.
 */
export function useStableHandler<Args extends unknown[], Result>(
  handler: (...args: Args) => Result,
): (...args: Args) => Result {
  const handlerRef = useRef(handler);
  handlerRef.current = handler;
  return useCallback((...args: Args) => handlerRef.current(...args), []);
}
